module.exports = __webpack_public_path__ + "static/media/github.5fdde4dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/github.svg
// module id = 39
// module chunks = 0